import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import { formatCurrencyDecimals, formatNumber } from 'utils/formats';

import InputCheckbox from 'modules/_shared/components/InputCheckbox';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

const PublishTradingOfferModalBody: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = usePublishTradingOfferModal();

  const className = data.tradingOffer?.className || '';
  const sharesCount = data.tradingOffer?.sharesCount?.total || 0;
  const sharePrice = data.tradingOffer?.sharePrice || 0;
  const totalOfferPrice = sharePrice * sharesCount;

  const partialSaleLabel = data.tradingOffer?.isPartialAmountEnabled
    ? t('Yes')
    : t('Nope');

  return (
    <Modal.Body>
      <div className="nk-modal">
        <div className="row">
          <div className="col-12 col-lg-6 mb-4">
            <div className="d-flex align-items-center gap-2">
              <span className="sub-text mr-2">{t('Class')}</span>
              <span className="h6 mb-0 w-200px d-block text-ellipsis">
                {className}
              </span>
            </div>
          </div>

          <div className="col-12 col-lg-6 mb-4">
            <div className="d-flex align-items-center gap-2">
              <span className="sub-text mr-2">{t('SharesNumber')}</span>
              <span className="h6 mb-0">{formatNumber(sharesCount)}</span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-6 mb-4">
            <div className="d-flex align-items-center gap-2">
              <span className="sub-text mr-2">{t('PricePerShare')}</span>
              <span className="h6 mb-0">
                {formatCurrencyDecimals(sharePrice)}
              </span>
            </div>
          </div>

          <div className="col-12 col-lg-6 mb-4">
            <div className="d-flex align-items-center gap-2">
              <span className="sub-text mr-2">{t('TotalPrice')}</span>
              <span className="h6 text-primary mb-0">
                {formatCurrencyDecimals(totalOfferPrice)}
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-6 mb-4">
            <div className="d-flex align-items-center gap-2">
              <span className="sub-text mr-2">{t('Validity')}</span>
              <span className="h6 mb-0">
                {`${data.validityDays} ${t('DayLowerCase')}/s`}{' '}
              </span>
            </div>
          </div>

          <div className="col-12 col-lg-6 mb-4">
            <div className="d-flex align-items-center gap-2">
              <span className="sub-text mr-2">{t('PartialSale')}</span>
              <span className="h6 mb-0">{partialSaleLabel}</span>
            </div>
          </div>
        </div>

        <div className="text-center">
          <InputCheckbox
            id="accept-terms-and-conditions=checkbox"
            label={t('IAcceptTermsAndConditions')}
            checked={data.isTermsAndConditionsAccepted}
            onChange={actions.handleChangeTermsAndConditionsAcceptance}
          />
        </div>
      </div>
    </Modal.Body>
  );
};

export default PublishTradingOfferModalBody;
